import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-send-finalized-playlist-confirm-dialog',
  template: `
    <h1 mat-dialog-title>Envoyer la sélection finalisée</h1>
    <div mat-dialog-content>
      <p style="color: #3d465a; margin-bottom: 16px;">
        Êtes-vous sûr de vouloir envoyer cette sélection finalisée ?
      </p>
      <div style="background-color: #fff3cd; border: 1px solid #ffc107; border-radius: 4px; padding: 12px;">
        <p style="margin: 0; color: #856404; font-size: 13px;">
          <strong>⚠️ Attention :</strong> Cette action est définitive. Elle va créer un brouillon de
          playlist sur Le Son Unique et enregistrer la position de diffusion finale de chaque titre
          dans Winmedia.
        </p>
      </div>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Annuler</button>
      <button mat-flat-button color="accent" (click)="onConfirm()">Envoyer</button>
    </div>
  `,
  styles: []
})
export class SendFinalizedPlaylistConfirmDialogComponent {
  constructor(public dialogRef: MatDialogRef<SendFinalizedPlaylistConfirmDialogComponent>) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
